module.exports = __webpack_public_path__ + "static/media/home2.da6aaf76.jpg";